export default {
  info: {
    member: {
      CustomerChoice: 'Customer Choice',
      CustomerName: 'Customer Name',
      CustomerType: 'Customer Type',
      ContactTel: 'Contact Tel',
      ComeFrom: 'ComeFrom',
      FromWeb: 'WebSite',
      FromAdmin: 'Admin Site',
      Member: 'Member',
      Agent: 'Agent',
      Designer: 'Designer',
      AgentName: 'Agent Name',
      SubordinateSalesman: 'Subordinate Salesman',
      SubordinateRegion: 'Subordinate Region',
      PriceLevel: 'Price Level',
      AccountName: 'Account Name',
      AccountBank: 'Account Bank',
      RegionChoice: 'RegionChoice',
      AccountNo: 'AccountNo',
      AgentChoice: 'AgentChoice',
      AgentID: 'AgentID',
      AgentCode: 'AgentCode',
      Advance: 'Advance',
      Due: 'Due',
      LevelName: 'LevelName',
      Region: 'Region',
      Salesman: 'Salesman',
      MemberName: 'MemberName',
      InitBalance: 'Init Balance',
      CreditLine: 'Credit Line',
      CautionMoney: 'Caution Money',
      AnnualMission: 'Annual Mission',
      OrderDiscount: 'Order Discount',
      ContactUs: '联系我们',
      DeliveryMode: '送货方式',
      FrequentlyQuestions: '常见问题解决',
      LegalDeclarations: '法律声明',
      PrivacyClauses: '隐私条款',
      TermsConditions: '条款与条项',
      JoinUs: '加入我们',
      Title: '标题',
      Category: '类别',
      SimpleDscription: '简要描叙',
      ProductCode: '产品编号',
      CategoryName: '类别名称',
      ProductName: '产品名称',
      PicUrl: '图片',
      JobName: '岗位名称',
      WorkingPlace: '上班地点',
      JobDescription: '岗位描叙',
      TipsTheme: '提示主题',
      Tips: '提示内容',
      Status: '状态',
      // 文件上传
      DocumentUpload: 'Document Upload',
      UploadData: 'Upload Data',
      FileName: 'File Name',
      FileSize: 'File Size',
      UploadTime: 'Upload Time',
      // 发布内容
      Published: 'Published',
      Unpublished: 'Unpublished'

    },
    memberTag: { // 会员标签
      tagName: 'Tag Name',
      tagDescription: 'Tag Description',
      addMemberTag: 'Add Member Tag',
      editMemberTag: 'Edit Member Tag',
      memberCount: 'Member Count',
      ChooseLabel: 'Choose Label',
      EditLabel: 'Edit Label',
      addLabel: 'Add Label'
    },
    memberService: { // 服务会员
      friendStatus: 'Friend Status',
      weChatMobile: 'WeChat Number',
      serviceTutor: 'Service Tutor',
      addServiceTutor: 'add Service Tutor',
      babyBirthday: 'Baby Birthday',
      babySex: 'Baby Sex',
      addFriends: 'Add Friends',
      Added: 'Added',
      notAdded: 'Not Added'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mmc/member.js